import React, { Component, Fragment } from "react";
import Fade from "react-reveal/Fade";

// logos
import BIT from "../logos/BIT.png";
import MLG from "../logos/MLG-Grau.png";
import LG from "../logos/LILL-GLOCK.png";
import wBIT from "../logos/BIT-Weiss.png";
import wMLG from "../logos/MLG-Weiss.png";
import wLG from "../logos/LILL-GLOCK-Weiss.png";

// components
import Title from "../components/Title";
import Article from "../components/Article";
import CardDeck from "../components/CardDeck/index";
import Contact from "../components/Contact";
import JTitle from "../components/JTitle";

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth
    };
    this.loadTop = this.loadTop.bind(this);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  loadTop() {
    var top = (document.getElementById("root").scrollTo =
      0 || window.scrollTo(0, 0));
    this.setState({
      i: top
    });
  }

  componentDidMount() {
    this.loadTop();
    window.addEventListener("load", this.loadTop);
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    this.loadTop();
    window.addEventListener("load", this.loadTop);
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  render() {
    const { navHeight } = this.props;
    const { width } = this.state;
    const isMobile = width <= 800;
    return (
      <Fragment>
        {!isMobile ? (
          <Title navHeight={navHeight} cards={cards} />
        ) : (
          <Fragment>
            <JTitle scrollToIntroRef={this.scrollToIntroRef} />
          </Fragment>
        )}
        <Fade>
          <Article style={{ zIndex: 3000 }} options={articleOptions} />
          <CardDeck cards={cards} />
          <Contact />
        </Fade>
      </Fragment>
    );
  }
}

const articleOptions = {
  header: [
    "Unsere Erfahrung für Ihren Erfolg",
    "Unsere Zusammmenarbeit für Ihre Zufriedenheit",
    "Unsere Leistung für Ihre Lösung"
  ],
  text: [
    "GLOCK & Partner, Notare · Rechtsanwälte · Steuerberater, M · L · G Steuerberatung und B · I · T Wirtschaftsberatung GmbH haben sich zu einem interdisziplinären Beraterverbund zusammengeschlossen. Unser Ziel ist es, unsere Mandanten umfassend auf juristischem, steuerrechtlichem und betriebswirtschaftlichem Gebiet ganzheitlich zu beraten und zu betreuen. Besonderen Wert legen wir hierbei auf die Qualität unserer Arbeitsergebnisse, die wir durch ständige Fortbildung unseres Teams und einzelne Fachkompetenzen bei den Partnern sicherstellen. Um zeitnah auf die Anfragen unserer Mandantschaft reagieren zu können, ordnen wir unseren Mandanten jeweils gezielt und fachorientiert Beratern zu.",
    "Aufgrund der unterschiedlichen Qualifikationen unserer Verbundpartner können wir unseren Mandanten eine breit gefächerte aber auch höchst spezialisierte Beratungsleistung anbieten.",
    "Wir hoffen, dass Sie auf den folgenden Seiten einen ersten Eindruck über unseren Partnerverbund bekommen. Wir freuen uns, wenn Sie mit uns Kontakt aufnehmen und wir uns in einem persönlichem Gespräch kennenlernen."
  ]
};

const cards = [
  {
    frontLogo: LG,
    backLogo: wLG,
    link: "http://www.lill-glock.de/htm/kanzlei.html",
    text:
      "Unsere Kanzlei bietet eine integrierte und ganzheitliche Rechtsberatung sowie Interessenvertretung. Die langjährige Erfahrung unserer Notare gewährleistet sichere Vertragsgestaltungen.",
    color: "5, 50, 25"
  },
  {
    frontLogo: MLG,
    backLogo: wMLG,
    link: "http://www.m-l-g.de",
    text:
      "Die M · L · G Steuerberatung bietet Ihnen neben den klassischen Aufgaben einer mittelständigen Steuerberatungskanzlei in einem Umfeld von Steuerberatern, Notaren, Rechtsanwälten und Unternehmensberatung einen interdisziplinären Verbund, der über die Region Rheingau hinaus tätig ist.",
    color: "0, 40, 75"
  },
  {
    frontLogo: BIT,
    backLogo: wBIT,
    link: "",
    text:
      "Wir beraten basierend auf besonderem Know-how und langjährigen Erfahrungswerten ihrer Berater, in allen betriebswirtschaftlichen Belangen: von der Existenzgründung über Finanzierungen bis hin zum Controlling.",
    color: "141,20,20"
  }
];
